// extracted by mini-css-extract-plugin
export var actionButton = "_c9-0";
export var attachmentLine = "_c9-1";
export var fileInput = "_c9-2";
export var fileUploadWrapper = "_c9-4";
export var footer = "_c9-3";
export var modalContent = "_c9-5";
export var paperclip = "_c9-6";
export var quillEditor = "_c9-7";